import { Duration } from 'moment';
import { EXCEPTION_STATUS } from 'src/constants/ELDConstants';
import { PENDING_EDITS } from 'src/constants/pendingEdtsConstants';

export interface HosFormInfo {
  title: string;
  data: string;
}

export interface HosEvent {
  status: string;
  startTime: string;
  duration: number | Duration;
  location: string;
  pcym: string;
  notes: string;
}
export interface HosDailyInfo {
  date?: {
    recordDate: string;
    startTime: string;
    timeZone: string;
  };
  carrier: {
    carrier: string;
    udot: string;
  };
  driver: {
    name: string;
    driverId: string;
    licenseNumber: string;
    licenseState: string;
    coDriver: string;
  };
  tractor: Array<{ id: string; vin: string }>;
  eld: {
    provider: string;
    registrationId: string;
    identifier: string;
  };
  logDate: string;
  periodStartTime: string;
  timezone: string;
  exemptStatus: string;
  exemptReason: string;
}
export interface HosStatus {
  time: string;
  status: number;
  origin?: number;
  location?: string;
  notes?: string;
}

export interface TimeLine {
  hosGridObject: HosStatus[];
  statusTimes: Duration[];
}

export enum PC_YM_STATUS {
  PC = 'PC',
  YM = 'YM',
}

export interface HosGridObject {
  index: number;
  status: number;
  time: string;
  timeISO: string;
  location: string;
  geoLocationData: GeoLocationDataType | null;
  notes: string;
  origin: number;
  duration: number | Duration;
  pcymStatus?: PC_YM_STATUS;
  inserted?: boolean;
  adminEditNotes?: string;
  editedTime?: boolean;
  odometer: number | null;
  editedOdometer: number | null;
}

export interface Exception {
  exceptionType: EXCEPTION_STATUS;
  exceptionId: string;
  shiftStartTime: number;
  shiftEndTime: number;
  notes: string;
  driverLocation: string;
  geoLocationData?: GeoLocationDataType;
  status: number;
}

export interface PendingEditsException {
  shorthand: string;
  exceptionCode: number;
  exceptionType: number;
  readableExceptionType: string;
  driverLocation: string;
  location: string;
  notes: string;
}

export interface CarrierInfo {
  carrierName: string;
  carrierAddress: string;
  carrierUsdot: string;
}
export interface Timer {
  time: number;
  timeToReset: number;
}

export interface UserLocationType {
  mt: string;
  lat: string;
  lng: string;
  speed: string;
  speedLimit: string;
  roadName: string;
  roadType: string;
  zip: string;
  city: string;
  state: string;
  powerUnitNumber: string;
}

export interface PendingEditsType {
  pendingEditsList: PendingEditsListType[];
  timelineData: TimeLine;
}

export interface PendingEditsListType {
  id: number;
  logDate: string;
  dateEdited: string;
  editedBy: PendingEditsEditedByType;
  hosGridObject: HosGridObject[];
  exceptions: PendingEditsException[];
  status: string;
  message: string;
  editType: number;
  claimMovement: boolean;
  checksum: string;
  editEndTimestamp: number;
}

export interface PendingEditsEditedByType {
  employeeName: string;
  employeeId: number;
}

export interface ApproveRejectPendingEditsType {
  logId: string;
  approveRejectData: ApproveRejectDataType;
}

export interface ApproveRejectDataType {
  editId: number;
  status: PENDING_EDITS;
  reason: string;
  checksum: string;
}

export interface GeoLocationDataType {
  distance_km: number;
  distance_mi: number;
  direction: string;
  city: string;
  lat: number;
  lng: number;
  jurisdiction: string;
  country: string;
}
